module.exports = __webpack_public_path__ + "img/bg_newsletter_intent.d2f2377.jpg";